import { render } from "./Balance.vue?vue&type=template&id=11db28d6&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=11db28d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11db28d6"

export default script